import { useRef, useState, useEffect, useMemo } from "react";
import emailjs from "emailjs-com";
import * as Yup from "yup";
import { SelectionJoursHoraires } from "./SelectionJoursHoraires";




// Schéma de validation avec Yup
const validationSchema = Yup.object().shape({
  prenom: Yup.string().required("Le nom de l'enfant est requis."),

  age: Yup.date()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .required("La date de naissance ou du terme sont requis."),

  nom: Yup.string().required("Le nom du parent 1 est requis."),

  emploiParent1: Yup.string().required("La profession est requise."),

  telephoneParent1: Yup.string()
    .required("Le numéro de téléphone du parent 1 est requis.")
    .matches(
      /^[0-9]{10}$/,
      "Le numéro de téléphone doit contenir 10 chiffres."
    ),
  nom2: Yup.string()
    .nullable()
    .min(2, "Le nom doit contenir au moins 2 caractères.")
    .required("Le nom du parent 1 est requis."),

  emploiParent2: Yup.string().required("La profession est requise."),

  telephoneParent2: Yup.string().matches(
    /^[0-9]{10}$/,
    "Le numéro de téléphone doit contenir 10 chiffres."
  ),

  // situation: Yup.string()
  //   .required("La situation est requise."),

  numbercaf: Yup.string()
    .required("Le numéro CAF est requis.")
    .matches(
      /^[a-zA-Z0-9]{6,10}$/,
      "Le numéro de la Caf doit contenir des caractères alphanumériques."
    ),

  email: Yup.string()
    .required("L'email est requis.")
    .email("Veuillez entrer une adresse email valide."),

  address: Yup.string().required("L'adresse est requise."),

  city: Yup.string().required("La ville est requise."),

  zipcode: Yup.string()
    .required("Le code postal est requis.")
    .matches(/^[0-9]{5}$/, "Le code postal doit contenir 5 chiffres."),

  dateEntree: Yup.date()
    .nullable() // Permet de gérer les valeurs null
    .transform((value, originalValue) => {
      return originalValue === "" ? null : value; // Transforme "" en null
    })
    .required("La date d'entrée souhaitée est requise."),
});

export const Formulaire = () => {
  const formRef = useRef();

  const [feedback, setFeedback] = useState(null);

  // 7,40€/heure
    const PrixFinalQF1 = useMemo(
      () => ({
        1: { 4.5: 19, 9: 38, 18: 77, 27: 115, 36: 153, 45: 292 },
        2: { 4.5: 19, 9: 38, 18: 77, 27: 115, 36: 173, 45: 428 },
        3: { 4.5: 19, 9: 38, 18: 77, 27: 115, 36: 308, 45: 564 },
      }),
      []
    );
  
    // 7,80€/heure
    const PrixFinalQF2 = useMemo(
      () => ({
        1: {
          // Niveau de revenu 1
          4.5: 20,
          9: 40,
          18: 81,
          27: 121,
          36: 161,
          45: 361,
        },
        2: {
          // Niveau de revenu 2
          4.5: 20,
          9: 40,
          18: 81,
          27: 121,
          36: 228,
          45: 497,
        },
        3: {
          // Niveau de revenu 3
          4.5: 20,
          9: 40,
          18: 81,
          27: 121,
          36: 364,
          45: 633,
        },
      }),
      []
    );
  
    // 8,20€/heure
    const PrixFinalQF3 = useMemo(
      () => ({
        1: {
          // Niveau de revenu 1
          4.5: 21,
          9: 42,
          18: 85,
          27: 127,
          36: 170,
          45: 430,
        },
        2: {
          // Niveau de revenu 2
          4.5: 21,
          9: 42,
          18: 85,
          27: 127,
          36: 283,
          45: 566,
        },
        3: {
          // Niveau de revenu 3
          4.5: 21,
          9: 42,
          18: 85,
          27: 127,
          36: 419,
          45: 702,
        },
      }),
      []
    );
  
    // 8,40€/heure
    const PrixFinalQF4 = useMemo(
      () => ({
        1: {
          // Niveau de revenu 1
          4.5: 22,
          9: 43,
          18: 87,
          27: 130,
          36: 174,
          45: 465,
        },
        2: {
          // Niveau de revenu 2
          4.5: 22,
          9: 43,
          18: 87,
          27: 130,
          36: 311,
          45: 601,
        },
        3: {
          // Niveau de revenu 3
          4.5: 22,
          9: 43,
          18: 87,
          27: 130,
          36: 446,
          45: 736,
        },
      }),
      []
    );
  
    // 8,60€/heure
    const PrixFinalQF5 = useMemo(
      () => ({
        1: {
          // Niveau de revenu 1
          4.5: 22,
          9: 45,
          18: 89,
          27: 134,
          36: 178,
          45: 499,
        },
        2: {
          // Niveau de revenu 2
          4.5: 22,
          9: 45,
          18: 89,
          27: 134,
          36: 338,
          45: 635,
        },
        3: {
          // Niveau de revenu 3
          4.5: 22,
          9: 45,
          18: 89,
          27: 134,
          36: 474,
          45: 771,
        },
      }),
      []
    );
  
    // 8,70€/heure
    const PrixFinalQF6 = useMemo(
      () => ({
        1: {
          // Niveau de revenu 1
          4.5: 23,
          9: 45,
          18: 90,
          27: 135,
          36: 180,
          45: 516,
        },
        2: {
          // Niveau de revenu 2
          4.5: 23,
          9: 45,
          18: 90,
          27: 135,
          36: 352,
          45: 652,
        },
        3: {
          // Niveau de revenu 3
          4.5: 23,
          9: 45,
          18: 90,
          27: 135,
          36: 488,
          45: 788,
        },
      }),
      []
    );
  
     // 8,80€/heure
    const PrixFinalQF7 = useMemo(
      () => ({
        1: {
          // Niveau de revenu 1
          4.5: 23,
          9: 46,
          18: 91,
          27: 137,
          36: 182,
          45: 534,
        },
        2: {
          // Niveau de revenu 2
          4.5: 23,
          9: 46,
          18: 91,
          27: 137,
          36: 366,
          45: 670,
        },
        3: {
          // Niveau de revenu 3
          4.5: 23,
          9: 46,
          18: 91,
          27: 137,
          36: 502,
          45: 805,
      },
    }),
    []
  );

  const handleReset = (e) => {
    e.preventDefault();

    setPrenom("");
    setAge("");
    setTerme("");
    setNom("");
    setEmploiParent1("");
    setTelephoneParent1("");

    setNom2("");
    setEmploiParent2("");
    setTelephoneParent2("");
    setSituation("");
    setNumbercaf("");

    setEmail("");
    setAddress("");
    setCity("");
    setZipcode("");
    setNombreEnfants("");
    setRevenu("");

    setMontantAide("");
    setSelectedTableQF("");
    setprixFinal("");

    setSelectedHours(""); // Réinitialiser les heures sélectionnées lorsque le quotient familial change
    setMonthlyCost(""); // Réinitialiser le coût mensuel
    // setSelectionDay(""); // Réinitialiser la sélection des jours et créneaux horaires
  };



  const [prenom, setPrenom] = useState("");
  const [age, setAge] = useState("");
  const [terme, setTerme] = useState("");

  const [nom, setNom] = useState("");
  const [emploiParent1, setEmploiParent1] = useState("");
  const [telephoneParent1, setTelephoneParent1] = useState("");

  const [nom2, setNom2] = useState("");
  const [emploiParent2, setEmploiParent2] = useState("");
  const [telephoneParent2, setTelephoneParent2] = useState("");

  const [numbercaf, setNumbercaf] = useState("");
  const [situation, setSituation] = useState("");

  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [dateEntree, setDateEntree] = useState("");

  // États pour les calculs
  const [nombreEnfants, setNombreEnfants] = useState("");
  const [revenu, setRevenu] = useState("");
  const [montantAide, setMontantAide] = useState("");
  const [selectedTableQF, setSelectedTableQF] = useState("");
  const [selectedHours, setSelectedHours] = useState("");
  const [monthlyCost, setMonthlyCost] = useState("");
  const [prixFinal, setprixFinal] = useState("");

  const [joursHoraires, setJoursHoraires] = useState({});


  const [commentaire, setcommentaire] = useState("");


  const [errors, setErrors] = useState({}); // Stocker les erreurs de validation


  const handleNombreEnfantsChange = (e) => {
    setNombreEnfants(e.target.value);
  };

  const handleRevenuChange = (e) => {
    setRevenu(e.target.value);
  };

  // Fonction pour gérer le changement du quotient familial
  const handleTableChange = (e) => {
    setSelectedTableQF(e.target.value);
    setSelectedHours(""); // Réinitialiser les heures sélectionnées lorsque le quotient familial change
    setMonthlyCost(""); // Réinitialiser le coût mensuel
    setprixFinal(""); // Réinitialiser le coût final
  };

  // Fonction pour gérer la sélection du nombre d'heures par semaine
  const handleHoursChange = (e) => {
    const hours = e.target.value;
    setSelectedHours(hours);

    // Tarifs horaires en fonction des différents quotients familiaux
    // const tarifHour1 = { 7.35},
    const tarifParHeureQF1 = {
      4.5: 128,
      9: 255,
      18: 511,
      27: 766,
      36: 1021,
      45: 1277,
    };

    // 7,80€/h
    const tarifParHeureQF2 = {
      4.5: 135,
      9: 269,
      18: 538,
      27: 807,
      36: 1076,
      45: 1346,
    };

    // 8,20€/h
    const tarifParHeureQF3 = {
      4.5: 141,
      9: 283,
      18: 566,
      27: 849,
      36: 1132,
      45: 1415,
    };

    // 8,40€/h
    const tarifParHeureQF4 = {
      4.5: 145,
      9: 290,
      18: 580,
      27: 869,
      36: 1132,
      45: 1415,
    };

    // 8,60€/h
    const tarifParHeureQF5 = {
      4.5: 148,
      9: 297,
      18: 593,
      27: 890,
      36: 1187,
      45: 1484,
    };

    // 8,70€/h
    const tarifParHeureQF6 = {
      4.5: 150,
      9: 300,
      18: 600,
      27: 900,
      36: 1201,
      45: 1501,
    };

     // 8,80€/h
    const tarifParHeureQF7 = {
      4.5: 152,
      9: 304,
      18: 607,
      27: 911,
      36: 1214,
      45: 1518,
    };
    // Sélectionner le tarif approprié en fonction du quotient familial choisi
    let cost = 0;
    switch (selectedTableQF) {
      case "1":
        cost = tarifParHeureQF1[hours];
        break;
      case "2":
        cost = tarifParHeureQF2[hours];
        break;
      case "3":
        cost = tarifParHeureQF3[hours];
        break;

      case "4":
        cost = tarifParHeureQF4[hours];
        break;

      case "5":
        cost = tarifParHeureQF5[hours];
        break;

      case "6":
        cost = tarifParHeureQF6[hours];
        break;

         case "7":
        cost = tarifParHeureQF7[hours];
        break;

      default:
        cost = 0;
    }

    setMonthlyCost(cost ? `${cost} €` : "");
  };

  useEffect(() => {
    let selectedRevenu = 0;

    if (revenu) {
      selectedRevenu = parseFloat(revenu);
    }

    setMontantAide(selectedRevenu.toFixed(2));
  }, [revenu]);

  useEffect(() => {
    if (selectedTableQF && selectedHours && revenu) {

      let prixFinalTable;

      // Tableau pour mapper les différentes valeurs QF
      const prixTables = [
        null, // Attention à cet index, il ne faut pas qu'il soit utilisé.
        PrixFinalQF1,
        PrixFinalQF2,
        PrixFinalQF3,
        PrixFinalQF4,
        PrixFinalQF5,
        PrixFinalQF6,
        PrixFinalQF7,
      ];
      prixFinalTable = prixTables[selectedTableQF];

      if (prixFinalTable) {
        // Déterminez la clé à utiliser pour le revenu
        const revenuKey =
          revenu === "992.13"
            ? "1"
            : revenu === "855.21"
              ? "2"
              : revenu === "718.41"
                ? "3"
                : null;

        const hoursKey = selectedHours; // On s'assure ici qu'il est bien un string compatible avec la clé.

        // Vérifiez que le revenuKey et hoursKey existent dans le prixFinalTable
        const prix =
          revenuKey && prixFinalTable[revenuKey]
            ? prixFinalTable[revenuKey][hoursKey]
            : null;

        // Mise à jour de prixFinal avec le montant calculé
        setprixFinal(prix !== null && prix !== undefined ? prix : null);
      }
    }
  }, [
    selectedTableQF,
    selectedHours,
    revenu,
    PrixFinalQF1,
    PrixFinalQF2,
    PrixFinalQF3,
    PrixFinalQF4,
    PrixFinalQF5,
    PrixFinalQF6,
     PrixFinalQF7
  ]);

  const handleSelectionChange = (selection) => {
    setJoursHoraires(selection);
  };





  // Fonction pour gérer la soumission du formulaire avec validation
  const handleSubmit = async (event) => {
    event.preventDefault(); // Empêche le rechargement de la page

    const formatJoursHoraires = (joursHoraires) => {
      let formattedJours = "";

      Object.keys(joursHoraires).forEach((jour) => {
        const jourData = joursHoraires[jour];

        if (jourData.selected) {
          formattedJours += `${jour.charAt(0).toUpperCase() + jour.slice(1)} :\n`;

          if (jourData.matin) {
            formattedJours += `  Matin : Arrivée: ${jourData.horaires.matinArrivee}, Départ: ${jourData.horaires.matinDepart || "Non défini"}\n`;
          }

          if (jourData.apresMidi) {
            formattedJours += `  Après-midi : Arrivée: ${jourData.horaires.apresMidiArrivee || "Non défini"}, Départ: ${jourData.horaires.apresMidiDepart}\n`;
          }

          if (jourData.repasMidi) {
            formattedJours += `  Repas midi : Oui\n`;
          }

          formattedJours += "\n"; // Séparer chaque jour
        }
      });

      return formattedJours || "Aucun jour sélectionné";
    };


    // Ajoute les horaires formatés à ton formData
    const formData = {
      prenom,
      age,
      terme,
      nom,
      emploiParent1,
      telephoneParent1,
      nom2,
      emploiParent2,
      telephoneParent2,
      numbercaf,
      situation,
      email,
      address,
      city,
      zipcode,
      dateEntree,
      nombreEnfants,
      revenu,
      montantAide,
      selectedTableQF,
      selectedHours,
      monthlyCost,
      prixFinal,
      commentaire,
      // Transforme les jours et horaires sélectionnés en texte lisible
      // joursHoraires: JSON.stringify(joursHoraires), // Ajout des jours et horaires sélectionnés
      joursHoraires: formatJoursHoraires(joursHoraires),

    };

    //     // Affiche les données pour vérifier
    // console.log("Formulaire soumis", formData);


    try {
      // Valider les données avec Yup
      await validationSchema.validate(formData, { abortEarly: false });

      console.log("Validation réussie, envoi en cours...");
      console.log("Email utilisateur :", formData.email);

      // Vérifier que l'email de l'utilisateur est bien présent
      if (!formData.email) {
        alert("Erreur : l'adresse email est vide. Vérifiez votre saisie.");
        return;
      }

      // Envoi du formulaire au propriétaire du site
      await emailjs.send(
        "service_zy05csa",
        "template_x3qcg8g",
        formData,
        "waYyANbn2-2SZaYWr"
      );
      console.log("Email principal envoyé avec succès.");

      // Envoi de l'email de confirmation à l'utilisateur
      await emailjs.send(
        "service_zy05csa",
        "template_pyko70i",
        {
          user_email: formData.email, // L'email de l'utilisateur
          user_name: formData.prenom, // Son prénom pour personnalisation
          message: "Merci pour votre inscription ! Nous reviendrons vers vous bientôt.",
        },
        "waYyANbn2-2SZaYWr"
      );
      // console.log("Email de confirmation envoyé avec succès.");

     setFeedback({
        type: 'success',
        message: 'Message envoyé avec succès !'
      });
    } catch (err) {
      if (err.inner) {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        setErrors(validationErrors);
        setFeedback({
          type: 'error',
          message: 'Veuillez corriger les erreurs avant de soumettre.'
        });
      } else {
        console.error("Erreur:", err);
        setFeedback({
          type: 'error',
          message: "Erreur lors de l'envoi. Veuillez réessayer."
        });
      }
    }

  };

  return (
    <>
      <section className="container mx-auto my-16 mt-36">
        <div>
          <div className="min-h-screen p-6 flex items-center justify-center">
            <form ref={formRef} onSubmit={handleSubmit} name="formulaire">
              <div className="container max-w-screen-lg mx-auto">
                <div>
                  <h2 className="font-semibold text-4xl text-green-800">
                    Formulaire de pré-inscription
                  </h2>

                  <div className="mt-3 bg-gradient-to-r from-red-200 to-indigo-200 rounded shadow-lg p-4 px-4 md:p-8 mb-6">
                    <div className="text-gray-600">
                      <p className="font-semibold text-xl mb-7 text-green-900 ">
                        Vos informations :
                      </p>
                    </div>
                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-1">
                      <div className="lg:col-span-2">
                        <div className="md:col-span-5">
                          <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-1">
                            <label className="lg:text-lg" htmlFor="Prenom">
                              Prénom et nom de l&rsquo;enfant
                            </label>
                            <input
                              type="text"
                              name="prenom"
                              id="prenom"
                              className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                              value={prenom}
                              onChange={(e) => setPrenom(e.target.value)}
                            />
                            {errors.prenom && (
                              <p className="error text-red-600 italic">
                                {errors.prenom}
                              </p>
                            )}
                          </div>

                          <div className="flex-1 md:col-span-5 mt-3 flex flex-wrap gap-4">
                            <div className="md:col-span-5">
                              <label className="lg:text-lg" htmlFor="age">
                                Date de naissance de l&rsquo;enfant
                              </label>
                              <input
                                type="date"
                                name="age"
                                id="age"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={age}
                                onChange={(e) => setAge(e.target.value)}
                              />
                              {errors.age && (
                                <p className="error text-red-600 italic">
                                  {errors.age}
                                </p>
                              )}
                            </div>

                            <div className="flex-1 md:col-span-5">
                              <label className="lg:text-lg" htmlFor="terme">
                                ou date du terme
                              </label>
                              <input
                                type="date"
                                name="terme"
                                id="terme"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                                value={terme}
                                onChange={(e) => setTerme(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="flex justify-center my-10">
                            <hr className="border border-white w-1/2" />
                          </div>

                              {/* PARENT 1 */}

                          {/* <p className="font-semibold text-xl mb-7 text-green-900 ">
                            Vos informations :
                          </p> */}
                          <div className="md:col-span-5 flex flex-col md:flex-row gap-4">
                            <div className="md:basis-2/5 min-w-0">
                              <label className="lg:text-lg" htmlFor="nom">
                                Prénom et nom - parent 1
                                {/* <div className="text-xs">(parent 1)</div> */}
                              </label>
                              <input
                                type="text"
                                name="nom"
                                id="nom"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={nom}
                                onChange={(e) => setNom(e.target.value)}
                              />
                              {errors.nom && (
                                <p className="error text-red-600 italic">
                                  {errors.nom}
                                </p>
                              )}
                            </div>

                            <div className="md:basis-[30%] min-w-0">
                              <label
                                className="lg:text-lg"
                                htmlFor="emploiParent1">
                                Profession
                                <span className="hidden lg:inline"> ou situation</span> {/* Cacher ce texte en mobile */}
                              </label>
                              <input
                                type="text"
                                name="emploiParent1"
                                id="emploiParent1"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50  border-black"
                                value={emploiParent1}
                                onChange={(e) =>
                                  setEmploiParent1(e.target.value)
                                }
                              />
                              {errors.emploiParent1 && (
                                <p className="error text-red-600 italic">
                                  {errors.emploiParent1}
                                </p>
                              )}
                            </div>

                            <div className="md:basis-[30%] min-w-0">
                              <label
                                className="lg:text-lg"
                                htmlFor="telephoneParent1">
                                Téléphone
                                {/* <div className="text-xs">(parent 1)</div> */}
                              </label>
                              <input
                                type="tel"
                                name="telephoneParent1"
                                id="telephoneParent1"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={telephoneParent1}
                                onChange={(e) =>
                                  setTelephoneParent1(e.target.value)
                                }
                              />
                              {errors.telephoneParent1 && (
                                <p className="error text-red-600 italic">
                                  {errors.telephoneParent1}
                                </p>
                              )}
                            </div>
                          </div>


                           {/* PARENT 2 */}

                          <div className="mt-6 md:col-span-5 flex flex-col md:flex-row gap-4">
                            <div className="md:basis-2/5 min-w-0">
                              <label className="lg:text-lg" htmlFor="nom2">
                                Prénom et nom - parent 2
                                {/* <div className="text-xs">(parent 2)</div> */}
                              </label>
                              <input
                                type="text"
                                name="nom2"
                                id="nom2"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={nom2}
                                onChange={(e) => setNom2(e.target.value)}
                              />
                              {errors.nom2 && (
                                <p className="error text-red-600 italic">
                                  {errors.nom2}
                                </p>
                              )}
                            </div>

                            <div className="md:basis-[30%] min-w-0">
                              <label
                                className="lg:text-lg"
                                htmlFor="emploiParent2">
                                Profession
                                <span className="hidden lg:inline"> ou situation</span> {/* Cacher ce texte en mobile */}
                              </label>
                              <input
                                type="text"
                                name="emploiParent2"
                                id="emploiParent2"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={emploiParent2}
                                onChange={(e) =>
                                  setEmploiParent2(e.target.value)
                                }
                              />
                              {errors.emploiParent2 && (
                                <p className="error text-red-600 italic">
                                  {errors.emploiParent2}
                                </p>
                              )}
                            </div>

                            <div className="md:basis-[30%] min-w-0">
                              <label
                                className="lg:text-lg"
                                htmlFor="telephoneParent2">
                                Téléphone
                                {/* <div className="text-xs">(parent 2)</div> */}
                              </label>
                              <input
                                type="tel"
                                name="telephoneParent2"
                                id="telephoneParent2"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50  border-black"
                                value={telephoneParent2}
                                onChange={(e) =>
                                  setTelephoneParent2(e.target.value)
                                }
                              />
                              {errors.telephoneParent2 && (
                                <p className="error text-red-600 italic">
                                  {errors.telephoneParent2}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="md:col-span-5 mt-3 flex justify-center flex-wrap gap-4">
                            <div className="flex-3">
                              <label className="md:text-lg" htmlFor="situation">
                                Situation familiale
                              </label>
                              <select
                                className="block w-full px-4 py-2 mt-1 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none
                                                                 focus:ring-blue-500 focus:border-blue-500"
                                name="situation"
                                id="situation"
                                value={situation}
                                onChange={(e) => setSituation(e.target.value)}>
                                <option value="maries">-- Choisir --</option>
                                <option value="maries">Mariés</option>
                                <option value="Pacses">Pacsés</option>
                                <option value="concubins">Concubins</option>
                                <option value="separes_ou_divorce">
                                  Séparés / divorcés
                                </option>
                                <option value="parent_seul">Parent isolé</option>
                              </select>
                            </div>


                            <div className="flex-3">
                              <label className="lg:text-lg" htmlFor="numbercaf">
                                Numéro de la CAF
                              </label>
                              <input
                                type="text"
                                name="numbercaf"
                                id="numbercaf"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={numbercaf}
                                onChange={(e) => setNumbercaf(e.target.value)}
                              />
                              {errors.numbercaf && (
                                <p className="error text-red-600 italic">
                                  {errors.numbercaf}
                                </p>
                              )}
                            </div>
                          </div>




                          <div className="flex justify-center my-10">
                            <hr className="border border-white w-1/2" />
                          </div>

                          <div className="md:col-span-5 mt-3">
                            <label className="lg:text-lg" htmlFor="email">
                              Mail
                            </label>
                            <input
                              type="text"
                              name="email"
                              id="email"
                              className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            {errors.email && (
                              <p className="error text-red-600 italic">
                                {errors.email}
                              </p>
                            )}
                          </div>

                          <div className="md:col-span-3 mt-3">
                            <label className="lg:text-lg" htmlFor="address">
                              Adresse
                            </label>
                            <input
                              type="text"
                              name="address"
                              id="address"
                              className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            />
                            {errors.address && (
                              <p className="error text-red-600 italic">
                                {errors.address}
                              </p>
                            )}
                          </div>

                          <div className="md:col-span-5 mt-3 flex justify-center flex-wrap gap-4">
                            <div className="md:col-span-2 mt-3 flex-1">
                              {/* Label pour grand écran */}
                              <label className="hidden sm:block lg:text-lg" htmlFor="zipcode">
                                Code Postal
                              </label>

                              {/* Label pour mobile */}
                              <label className="block sm:hidden lg:text-lg" htmlFor="zipcode">
                                CP
                              </label>

                              <input
                                type="text"
                                name="zipcode"
                                id="zipcode"
                                className="text-xs lg:text-lg transition-all flex items-center h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={zipcode}
                                onChange={(e) => setZipcode(e.target.value)}
                              />

                              {errors.zipcode && (
                                <p className="error text-red-600 italic">
                                  {errors.zipcode}
                                </p>
                              )}
                            </div>


                            <div className="md:col-span-5 mt-3 flex-3">
                              <label className=" lg:text-lg" htmlFor="city">
                                Ville
                              </label>
                              <input
                                type="text"
                                name="city"
                                id="city"
                                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                              />
                              {errors.city && (
                                <p className="error text-red-600 italic">
                                  {errors.city}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="flex justify-center my-10">
                            <hr className="border border-white w-1/2" />
                          </div>

                          <div className="md:col-span-5">
                            <label className="lg:text-lg" htmlFor="dateEntree">
                              Date d'entrée souhaitée
                            </label>
                            <input
                              type="date"
                              name="dateEntree"
                              id="dateEntree"
                              className="h-10 border mt-1 rounded px-4 w-full bg-gray-50"
                              value={dateEntree}
                              onChange={(e) => setDateEntree(e.target.value)}
                            />
                            {errors.dateEntree && (
                              <p className="error text-red-600 italic">
                                {errors.dateEntree}
                              </p>
                            )}
                          </div>

                          <SelectionJoursHoraires onSelectionChange={handleSelectionChange} />


                          <div className="md:col-span-5 mt-3">
                            <label className="lg:text-lg" htmlFor="commentaire">
                              Commentaire ou précisions
                            </label>
                            <textarea
                              type="text"
                              name="commentaire"
                              id="commentaire"
                              className="h-32 border mt-1 rounded px-4 w-full bg-gray-50 border-black"
                              value={commentaire}
                              onChange={(e) => setcommentaire(e.target.value)}
                            />
                            {errors.commentaire && (
                              <p className="error text-red-600 italic">
                                {errors.commentaire}
                              </p>
                            )}
                          </div>

                          <div className="md:col-span-3 mt-10 border-gray-500 border rounded-md p-2">

                            <p className="w-full text-green-700 italic flex justify-center">
                              Ce formulaire est une simulation. Les résultats sont donnés à titre indicatif et n’ont aucune valeur contractuelle.
                            </p>
                            <div className="flex flex-col md:flex-row justify-center md:space-x-6 p-5 md:w-full mt-3">
                              {/* Estimation Creche */}
                              <div className="md:w-3/5 w-full  md:col-span-8 lg:col-span-12 bg-blue-200 rounded-md p-5 h-3/4">
                                <div>
                                  <p className="lg:text-md font-semibold text-indigo-900">
                                    Tarifications Micro-crèche
                                  </p>
                                </div>
                                <div className="md:col-span-5 mt-2"></div>

                                {/* Sélection du quotient familial */}
                                <div className="md:col-span-3 mt-3">
                                  <label
                                    className="text-sm lg-text-md mt-3 font-semibold"
                                    htmlFor="selectedTableQF">
                                    Sélectionner votre quotient familial :
                                  </label>
                                  <select
                                    name="selectedTableQF"
                                    id="selectedTableQF"
                                    className="block w-full px-4 py-2 mt-1 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none
                                                                 focus:ring-blue-500 focus:border-blue-500"
                                    value={selectedTableQF}
                                    onChange={handleTableChange}>
                                    <option value="0">
                                      -- Quotient familial --
                                    </option>
                                    <option value="1">0 - 750 €</option>
                                    <option value="2">750 - 1000 €</option>
                                    <option value="3">1000 - 1250 €</option>
                                    <option value="4">1250 - 1500 €</option>
                                    <option value="5">1500 - 1750 €</option>
                                    <option value="6">2500 - 3000 €</option>
                                    <option value="7">
                                      supérieur à 3000 €
                                    </option>
                                  </select>
                                </div>

                             <div className="">
                                  {selectedTableQF === "1" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className=" border border-gray-300 rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-white rounded-t-md">
                                          Tarif horaire à 7,40€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  {selectedTableQF === "2" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className=" border border-gray-300 rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-gray-300 rounded-t-md">
                                          Tarif horaire à 7,80€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  {selectedTableQF === "3" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className=" border border-gray-300 rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-gray-300 rounded-t-md">
                                          Tarif horaire à 8,20€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  {selectedTableQF === "4" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className=" border border-gray-300 rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-gray-300 rounded-t-md">
                                          Tarif horaire à 8,40€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  {selectedTableQF === "5" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className=" border border-gray-300 rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-gray-300 rounded-t-md">
                                          Tarif horaire à 8,60€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  {selectedTableQF === "6" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className="border border-white rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-gray-300 rounded-t-md">
                                          Tarif horaire à 8,70€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                <div className="">
                                  {selectedTableQF === "7" && (
                                    <div
                                      id="TQF1"
                                      value={selectedTableQF}
                                      onChange={handleTableChange}
                                      className="mt-2">
                                      <div className="border border-white rounded-md">
                                        <p className="p-2 md:text-sm font-semibold text-red-800 border-gray-300 rounded-t-md">
                                          Tarif horaire à 8,80€/h
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/* // Sélection des heures si applicable */}


                                {/* <option value="4.5">
                                        {/* 4.5 heures par semaine  */}
                                {/* 1/2 journée (pour information)
                                      </option> */}


                                {selectedTableQF && (
                                  <div className="md:col-span-3 mt-3">
                                    <label
                                      className="text-sm lg-text-md mt-3 font-semibold"
                                      htmlFor="selectedHours">
                                      Nombre de journées d&rsquo;accueil par
                                      semaine
                                    </label>
                                    <select
                                      className="block w-full px-4 py-2 mt-1 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm 
                                                                    focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                      id="selectedHours"
                                      name="selectedHours"
                                      value={selectedHours}
                                      onChange={handleHoursChange}>
                                      <option value="">
                                        Nombre de journées
                                      </option>

                                      <option value="9">
                                        {/* 9 heures par semaine */}
                                        1 journée
                                      </option>
                                      <option value="18">
                                        {/* 18 heures par semaine */}
                                        2 journées
                                      </option>
                                      <option value="27">
                                        {/* 27 heures par semaine */}
                                        3 journées
                                      </option>
                                      <option value="36">
                                        {/* 36 heures par semaine */}
                                        4 journées
                                      </option>
                                      <option value="45">
                                        {/* 45 heures par semaine */}
                                        5 journées
                                      </option>
                                    </select>
                                    <div className="mt-3 italic text-red-700 font-semibold text-[12px] text-center w-full">
                                      <p className="text-center">
                                        <span className="inline-flex items-center">
                                          {/* <img className="size-4 mr-1" src="assets/img/exclamation.png" alt="attention" /> */}
                                          Attention, le calcul d'une journée correspond à 9h
                                        </span>
                                      </p>
                                    </div>



                                  </div>
                                )}

                                <div className="border border-blue-400 p-2 rounded-md mt-4">
                                  <p className="md:text-md text-green-900 ">
                                    Coût mensuel
                                  </p>
                                  <p className="font-light italic text-xs">
                                    (PAJE non déduite)
                                  </p>

                                  {/* Affichage du coût mensuel */}
                                  {monthlyCost && (
                                    <div className="mt-3">
                                      <p
                                        id="monthlyCost"
                                        name="monthlyCost"
                                        value={monthlyCost}
                                        onChange={(e) =>
                                          setMonthlyCost(e.target.value)
                                        }
                                        className="text-red-800 text-2xl mt-4">
                                        {monthlyCost}
                                      </p>
                                    </div>
                                  )}
                                </div>



                                <div className="text-xs  mt-2 italic">(Le tarif horaire comprend les couches et les repas hors alimentation lactée des bébés).</div>

                                <div className="md:col-span-2 mt-3">
                                  <button
                                    id="reset-button"
                                    className="bg-red-500 hover:bg-red-500 text-white text-xs items-center px-4 py-2 rounded-lg"
                                    onClick={handleReset}>
                                    Réinitialiser le calcul
                                  </button>
                                </div>
                              </div>

                              {/* Formulaire calcul PAJE */}
                              <div className="bg-blue-200 p-5 rounded-md md:w-2/4">
                                <div className="md:col-span-5">
                                  <label
                                    className="lg:text-sm font-semibold text-indigo-900"
                                    htmlFor="Prenom">
                                    Calcul de l&rsquo;aide de la PAJE
                                    <p className="text-sm font-normal">
                                      (Prestation d'Accueil Jeune Enfant)
                                    </p>
                                  </label>
                                </div>

                                <div
                                  className="text-sm lg-text-md mt-3 font-semibold">
                                  <label htmlFor="nombreEnfants">
                                    Nombre d&rsquo;enfants (au foyer) :
                                  </label>
                                </div>

                                <div className="md:col-span-2 mt-2">
                                  <select
                                    id="nombreEnfants"
                                    className="block w-full px-4 py-2 mt-1 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none
                                                                 focus:ring-blue-500 focus:border-blue-500"
                                    value={nombreEnfants}
                                    onChange={handleNombreEnfantsChange}>
                                    <option value="">
                                      -- Nombre d&rsquo;enfants --
                                    </option>
                                    <option value="1">1 enfant</option>
                                    <option value="2">2 enfants</option>
                                    <option value="3">3 enfants</option>
                                  </select>
                                </div>

                                <div
                                  className="text-sm lg-text-md mt-3 font-semibold">
                                  <label className="" htmlFor="revenu">
                                    Plafond de revenu du
                                    foyer :
                                  </label>
                                </div>
                                <div className="md:col-span-2 mt-2">
                                  <select
                                    name="revenu"
                                    id="revenu"
                                    className="block w-full px-4 py-2 mt-1 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none
                                    focus:ring-blue-500 focus:border-blue-500"
                                    value={revenu}
                                    onChange={handleRevenuChange}>
                                    <option
                                      className="lg:text-lg p-3 "
                                      value="">
                                      -- Plafond de revenu --
                                    </option>
                                    <option value="992.13">
                                      Revenus 1 &lt;{" "}
                                      {nombreEnfants === "1"
                                        ? "24 333 €"
                                        : nombreEnfants === "2"
                                          ? "27 786 €"
                                          : "31 239 €"}
                                    </option>
                                    <option value="855.21">
                                      Revenus 2 &lt;{" "}
                                      {nombreEnfants === "1"
                                        ? "54 075€"
                                        : nombreEnfants === "2"
                                          ? "61 751 €"
                                          : "69 427 €"}
                                    </option>
                                    <option value="718.41">
                                      Revenu 3 &gt;{" "}
                                      {nombreEnfants === "1"
                                        ? "54 075 €"
                                        : nombreEnfants === "2"
                                          ? "61 751 €"
                                          : "69 427 €"}
                                    </option>
                                  </select>
                                </div>

                                <div className="md:col-span-2 mt-6">
                                  <div className="mt-3">
                                    <p className="text-md text-green-900">
                                      Montant CAF pour les - de 3 ans :
                                    </p>
                                    <p
                                      className="mt-4 text-green-800 text-2xl"
                                      name="montantAide"
                                      id="montantAide">
                                      {montantAide} €
                                    </p>
                                  </div>
                                </div>

                                <div className="md:col-span-5 mt-3">

                                </div>
                              </div>

                              {/* Resultat cout */}
                              <div className="md:w-1/4 border bg-blue-100 p-5 rounded-md mt-3 md:mt-0">
                                {/* Afficher le montant d'aide calculé */}
                                <div className="mt-8 bg-green-700 p-2 rounded-md">
                                  <p className="text-lg text-white">
                                    Coût mensuel estimé :
                                  </p>
                                  <p className="font-light italic text-xs text-gray-200">
                                    (PAJE déduite)
                                  </p>
                                  {montantAide > 0 && (
                                    <div className="md:col-span-3 mt-3">
                                      <p
                                        name="prixFinal"
                                        className="text-4xl text-white mt-3">
                                        {" "}
                                        {prixFinal} €
                                      </p>
                                    </div>
                                  )}
                                </div>

                                <div className="flex justify-center my-10">
                                  <hr className="border border-white w-1/2" />
                                </div>

                                <div className="text-xs mt-10 text-justify font-semibold text-red-700">
                                  À ce coût mensuel estimé, il faut encore
                                  déduire le crédit d'impôt de 50% du mode de
                                  garde avec un montant maximum de 1750€/an,
                                  soit 146€/mois à déduire de vos frais.
                                </div>

                                <input
                                  type="hidden"
                                  name="selectionDayTableHTML"
                                />

                                <input
                                  type="hidden"
                                  name="nombreEnfants"
                                  value={nombreEnfants}
                                />


                                <input
                                  type="hidden"
                                  name="montantAide"
                                  value={montantAide}
                                />


                                <input
                                  type="hidden"
                                  name="prixFinal"
                                  value={prixFinal}
                                />

                                <input
                                  type="hidden"
                                  name="monthlyCost"
                                  value={monthlyCost}
                                />


                              </div>
                            </div>
                          </div>
                          <div className="md:col-span-5 text-right mt-4">
                            <div className="inline-flex items-end">
                              <button
                                type="submit"
                                className="bg-green-600 hover:bg-blue-700 active:scale-105 text-white text-lg font-bold py-4 px-6 rounded cursor-pointer transition-transform duration-100">                                Envoyé
                              </button>
                            </div>
                          </div>

             {/* Feedback formulaire */}
                          {feedback && (
                            <div className={`md:col-span-5 mt-3 p-3 rounded text-lg ${
                              feedback.type === 'success'
                                ? 'bg-green-100 text-green-900'
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {feedback.message}
                            </div>
                          )}


                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <h2 className="text-xs text-justify mb-4 italic p-4">
            * Important : Notre structure se présente sous forme d’une petite
            SARL, elle est donc privée. Nous fonctionnons avec la PAJE
            micro-crèche. Ce type de modalité implique que nous facturons aux
            parents la globalité du coût du mode de garde et que la CAF reverse
            chaque mois aux parents (directement sur leur compte bancaire) une
            prestation évaluée en fonction des revenus annuels des parents. De
            même, il est important de rappeler que dans le cadre d’un contrat
            avec la micro-crèche, le parent n’est pas employeur contrairement à
            l’emploi d’une assistante maternelle. Le parent n’a donc aucune
            responsabilité particulière envers les salariés. La famille paie
            simplement une prestation de service. La CAF applique un plafond de
            prestation qu’il ne dépasse pas. Quoi qu’il en soit (si la facture
            mensuelle de la crèche est peu élevée) les parents garderont à leur
            charge 15% du montant du mode de garde. Une fois inscrit à la CAF,
            la responsable remplira directement (avec l’accord préalable des
            parents) une télé déclaration par internet sur un réseau sécurisé.
            C’est d’après cette télédéclaration que les services de la CAF se
            basent pour verser les prestations aux familles. Les parents n’ont
            donc aucune démarche à réaliser chaque mois. Notre structure
            applique un tarif variable en fonction des revenus des familles.
            Nous nous basons sur les QF (quotient familial de la CAF). Nous
            utilisons une facturation forfaitaire. Une demi-journée est facturée
            sur une base de 4h30 et une journée de 9h00. Tout dépassement,
            c&rsquo;est-à-dire toute journée de l’enfant qui excéderait 9h sera
            facturée au même tarif horaire sans supplément. En cas de litige, il
            est possible de faire appel à un médiateur à la consommation :Mme
            Laurence PRUD’HOMME / Tél. : 06 12 95 62 18 / mail :
            laurence.prudhomme@free.fr
          </h2>

          <div>
            <p className="text-xs text-justify italic">
              Les informations recueillies sur ce site sont enregistrées dans un
              fichier informatisé par la Micro-crèche Grain de Malice pour
              pré-inscription. La base légale du traitement sont les intérêts
              légitimes des deux parties pour la préinscription. Les données
              collectées seront communiquées aux seuls destinataires suivants :
              émetteur du formulaire et la micro-crèche Grain de Malice. Les
              données sont conservées pendant le temps de l&rsquo;inscription et
              pour une durée de 36 mois maximum selon le RGPD. Vous pouvez
              accéder aux données vous concernant, les rectifier, demander leur
              effacement ou exercer votre droit à la limitation du traitement de
              vos données. (en fonction de la base légale du traitement,
              mentionner également : Vous pouvez retirer à tout moment votre
              consentement au traitement de vos données ; Vous pouvez également
              vous opposer au traitement de vos données ; Vous pouvez également
              exercer votre droit à la portabilité de vos données) Consultez le
              site cnil.fr pour plus d’informations sur vos droits. Pour exercer
              ces droits ou pour toute question sur le traitement de vos données
              dans ce dispositif, vous pouvez contacter La Micro-Crèche : 41 Rue
              Marx Dormoy, 42300 Roanne - Tél. : 09 81 65 51 57 ou 06 69 43 55
              26 - microcrecheroanne@gmail.com Si vous estimez, après nous avoir
              contactés, que vos droits « Informatique et Libertés » ne sont pas
              respectés, vous pouvez adresser une réclamation à la CNIL.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
